"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_1_ = _interopRequireDefault(require("../images/help_1_4.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var skill = {
  id: "skill",
  title: {
    en: "Lesson 4 (Skill)",
    de: "Lektion 4 (Fähigkeiten)"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_1_.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Use of skill"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "Depending on the class, characters can learn special skills."), /*#__PURE__*/_react.default.createElement("li", null, "The experience points you gain from the battles can be used to increase your characters level. When you increase a level, 2 skill points will be earned."), /*#__PURE__*/_react.default.createElement("li", null, "You can save skill points and use them to learn different skills in the skill window, shortcut key (K)."), /*#__PURE__*/_react.default.createElement("li", null, "When you learn a skill, the skills will be a little bit brighter. Click on the skill icon, drag it to a shortcut slot and you can record a skill to a shortcut key."), /*#__PURE__*/_react.default.createElement("li", null, "Remember that during battle, when you use your skills it brings better and safer results in your hunt."), /*#__PURE__*/_react.default.createElement("li", null, "We recommend you use your skills often, the more it is used the stronger it will become, so get to know your skills and use them often."), /*#__PURE__*/_react.default.createElement("li", null, "If you like to learn more about the skill system, look at characters skill tab."), /*#__PURE__*/_react.default.createElement("li", null, "When you are familiar with continual skills and cooperational skills you can use them easily.")))
  }
};
var _default = skill;
exports.default = _default;